import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Box, Button, Stack, Typography } from '@mui/material';
import SelectWithFetch from '../../configured-components/form/configured-inputs/select/SelectWithFetch';

const StaticUserSelection = () => {
    const { watch, setValue } = useFormContext();

    const selectedType = watch('type');

    const getSelectedUserTypeConfig = () => {
        const typeToUse = selectedType || 'producer';

        const label = `${typeToUse.charAt(0).toUpperCase() + typeToUse.slice(1)}s`;

        const isTransport = typeToUse === 'transport';
        const secondaryKey = isTransport ? 'hauler_number' : 'license_number';
        const fields = ['_id', 'name', secondaryKey];
        const optionLabel = {
            keys: ['name', secondaryKey],
            connector: ' - ',
        };

        return {
            name: 'users',
            query: {
                endpoint: '/users/populated',
                where: { role: typeToUse, subuser: { eq: false } },
                fields,
            },
            label,
            optionLabel,
        };
    };

    const selectedUserTypeConfig = getSelectedUserTypeConfig();

    const clearUsers = () => {
        setValue(selectedUserTypeConfig.name, []);
    };

    return (
        <Stack spacing={4}>
            <Stack spacing={1}>
                <Typography variant="h6" component="h3" sx={{ color: 'text.primary', fontWeight: 500 }}>
                    Static User Selection
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Select users from the chosen category to add to this group
                </Typography>
            </Stack>
            <Box>
                <Button variant="contained" color="error" size="small" onClick={clearUsers}>
                    Clear Selection
                </Button>
            </Box>

            {selectedUserTypeConfig ? (
                <SelectWithFetch
                    key={selectedType || 'producer'}
                    name={selectedUserTypeConfig.name}
                    query={selectedUserTypeConfig.query}
                    props={{
                        label: selectedUserTypeConfig.label,
                        multiple: true,
                        widths: { xs: 12, sm: 6 },
                        optionLabel: selectedUserTypeConfig.optionLabel,
                    }}
                />
            ) : (
                <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                    Please select a role type above to choose users
                </Typography>
            )}
        </Stack>
    );
};

export default StaticUserSelection;
